import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const MyFilesMetadata = ({ show, onHide, metadata }) => (
  <Modal show={show} onHide={onHide} centered>
    <Modal.Header>
      <Modal.Title>File Metadata</Modal.Title>
      <button
        type="button"
        className="bg-transparent fw-bold"
        onClick={onHide}
        aria-label="Close"
      >
        <i className="bi bi-x-lg me-2"></i>
      </button>
    </Modal.Header>
    <Modal.Body>
      {metadata ? (
        <table className="table table-bordered">
          <tbody>
            {Object.entries(metadata).map(([key, value]) => (
              <tr key={key}>
                <td style={{ textTransform: 'capitalize', fontWeight: 500 }}>{key.replace(/_/g, ' ')}</td>
                <td>{value || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="text-center text-muted">Metadata not available.</div>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
);

export default MyFilesMetadata; 